<template>
  <!-- Footer -->
  <footer class="px-4 d-flex justify-content-between footer">

    <!-- Details -->
     <p>&copy; {{ new Date().getFullYear() }} CCF Fibreglass. All rights reserved.</p>


      <small>Powered by <a class="powered-by" href="https://www.blackstarmerchants.com">Blackstar Merchant Services</a></small>
   



  </footer>
</template>

<script>
export default {
  name: 'RuggedSeparator',
  props: {
    isTop: {
      type: Boolean,
      default: true
    }
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer {
  width: 100%;
  background-color: rgb(33, 34, 37);
  color:rgba(255, 255, 255, 0.724);
  height:80px;
  align-items: center;
}

.sitemap a {
  height: 30px;
}

.powered-by {
  font-weight:bold;
  color:rgb(149, 222, 94);
}

</style>
